import { css } from '@emotion/react'
import { Button, ButtonGroup } from 'bold-ui'

export type EstadoBotaoProntuarioFamiliar = 'DADOS_IMOVEL' | 'VISITAS'
interface ProntuarioFamiliarButtonGroupProps {
  estadoBotao: EstadoBotaoProntuarioFamiliar
  setEstadoBotao(estado: EstadoBotaoProntuarioFamiliar): void
}

export const ProntuarioFamiliarButtonGroup = ({ estadoBotao, setEstadoBotao }: ProntuarioFamiliarButtonGroupProps) => {
  return (
    <ButtonGroup
      style={css`
        margin: 2rem auto 1rem;
      `}
    >
      <Button
        kind={estadoBotao === 'DADOS_IMOVEL' ? 'primary' : 'normal'}
        size='small'
        skin='default'
        onClick={() => setEstadoBotao('DADOS_IMOVEL')}
      >
        Dados do imóvel
      </Button>
      <Button
        kind={estadoBotao === 'VISITAS' ? 'primary' : 'normal'}
        size='small'
        skin='default'
        onClick={() => setEstadoBotao('VISITAS')}
      >
        Visitas realizadas
      </Button>
    </ButtonGroup>
  )
}
